import { render, staticRenderFns } from "./faqComponent.vue?vue&type=template&id=780bf3af&scoped=true&"
import script from "./faqComponent.vue?vue&type=script&lang=js&"
export * from "./faqComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780bf3af",
  null
  
)

export default component.exports